export default __webpack_public_path__ + "static/totem-4ee45fa916ee1ecd549e1d82c16a30c5.png";